import { Locale } from '@/constants/locale';
import useLocale from '@/hooks/useLocale';
import { Image } from '@/components/Image';

const LANGUAGES = [
  { iconSrc: '/icons/usa.svg', label: 'ENGLISH', locale: Locale.EN },
  { iconSrc: '/icons/china.svg', label: '简体', locale: Locale.ZH },
  { iconSrc: '/icons/japan.svg', label: '日本語', locale: Locale.JA },
  { iconSrc: '/icons/spain.svg', label: 'Español', locale: Locale.ES }
] as const;

interface LanguageItemProps {
  iconSrc: string;
  label: string;
  selected: boolean;
  onClick?: () => void;
}

const LanguageItem = ({ iconSrc, label, selected, onClick }: LanguageItemProps) => (
  <button
    className={`w-[120px] h-10 rounded-[10px] flex flex-row items-center justify-center cursor-pointer ${
      selected ? 'bg-white [box-shadow:0px_4px_20px_0px_rgba(0,0,0,0.08)]' : 'bg-transparent'
    }`}
    onClick={() => {
      onClick?.();
    }}
  >
    <Image src={iconSrc} alt="language icon" className="w-5 h-6" width={20} height={24} />
    <span className={`font-sans text-[18px] leading-[26px] font-medium ml-1 ${selected ? 'text-black' : 'text-[#bfbfbf]'}`}>
      {label}
    </span>
  </button>
);

const LocaleSelection = () => {
  const { locale, changeLocale } = useLocale();

  return (
    <div className="flex flex-row p-2.5 bg-[#f9f9f9] border border-[#f5f5f5] absolute bottom-5 left-1/2 -translate-x-1/2 rounded-[10px]">
      {LANGUAGES.map((language) => (
        <LanguageItem
          key={language.label}
          iconSrc={language.iconSrc}
          label={language.label}
          selected={language.locale === locale}
          onClick={() => {
            changeLocale(language.locale);
          }}
        />
      ))}
    </div>
  );
};

export default LocaleSelection;
